// @flow

import * as React from 'react';

import { CartButton } from './CartButton';

import styles from './PriceArea.scss';

type Props = {
  onClick: (evt: SyntheticMouseEvent<>) => Promise<void> | mixed,
  children: ?React.Node,
  loading: boolean,
  isCartActionnable: boolean,
  addedToCart: boolean,
};

export function PriceArea({
  children,
  onClick,
  loading,
  addedToCart,
  isCartActionnable,
}: Props): React.MixedElement {
  return (
    /* prix +  cart button */
    <div className={styles.root}>
      {/* prix */}
      {children}
      {/* cart button */}
      <CartButton
        onClick={onClick}
        loading={loading}
        isCartActionnable={isCartActionnable}
        addedToCart={addedToCart}
      />
    </div>
  );
}
